import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import ExpertBaseInfo from '@/types/table/expertBaseInfo';
import { ExpertBooksData } from '@/api/generated/expertBooksController';
import { ExpertCoursesData } from '@/api/generated/expertCoursesController';
import { ExpertContactInfoData } from '@/api/generated/expertContactInfoController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ExpertBaseInfoData extends ExpertBaseInfo {
  expertBooksList?: ExpertBooksData[];
  expertCoursesList?: ExpertCoursesData[];
  expertContactInfoList?: ExpertContactInfoData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ExpertBaseInfoController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ExpertBaseInfoData>>(API_CONTEXT + '/app/expertBaseInfo/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ExpertBaseInfoData>(API_CONTEXT + '/app/expertBaseInfo/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/expertBaseInfo/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/expertBaseInfo/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/expertBaseInfo/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/expertBaseInfo/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/expertBaseInfo/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/expertBaseInfo/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/expertBaseInfo/deleteBatch', params, httpOptions);
  }
}
